// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SafelinkRouteImport } from './routes/safelink'
import { Route as RedirectRouteImport } from './routes/redirect'
import { Route as RandomRouteImport } from './routes/random'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PlayRouteImport } from './routes/play'
import { Route as MoviesRouteImport } from './routes/movies'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as DebugDeviceRouteImport } from './routes/debug-device'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SeriesIndexRouteImport } from './routes/series.index'
import { Route as CategoriesIndexRouteImport } from './routes/categories.index'
import { Route as StorySlugRouteImport } from './routes/story.$slug'
import { Route as SeriesSlugRouteImport } from './routes/series.$slug'
import { Route as MovieSlugRouteImport } from './routes/movie.$slug'
import { Route as CategoriesSlugRouteImport } from './routes/categories.$slug'
import { Route as CThreadIdRouteImport } from './routes/c.$threadId'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminStoriesRouteImport } from './routes/admin.stories'
import { Route as AdminSafelinkRouteImport } from './routes/admin.safelink'
import { Route as AdminPreviewRouteImport } from './routes/admin.preview'
import { Route as AdminNewsletterRouteImport } from './routes/admin.newsletter'
import { Route as AdminMonitorRouteImport } from './routes/admin.monitor'
import { Route as AdminHelpRouteImport } from './routes/admin.help'
import { Route as AdminContactRouteImport } from './routes/admin.contact'
import { Route as AdminCommentsRouteImport } from './routes/admin.comments'
import { Route as AdminBlockedCountriesRouteImport } from './routes/admin.blocked-countries'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.index'
import { Route as DashboardPendingRouteImport } from './routes/dashboard.pending'
import { Route as WatchSlugEpRouteImport } from './routes/watch.$slug.$ep'
import { Route as DownloadMovieSlugRouteImport } from './routes/download.movie.$slug'
import { Route as DownloadSlugEpRouteImport } from './routes/download.$slug.$ep'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SafelinkRoute = SafelinkRouteImport.update({
            id: '/safelink',path: '/safelink',getParentRoute: () => rootRouteImport
          })
const RedirectRoute = RedirectRouteImport.update({
            id: '/redirect',path: '/redirect',getParentRoute: () => rootRouteImport
          })
const RandomRoute = RandomRouteImport.update({
            id: '/random',path: '/random',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PlayRoute = PlayRouteImport.update({
            id: '/play',path: '/play',getParentRoute: () => rootRouteImport
          })
const MoviesRoute = MoviesRouteImport.update({
            id: '/movies',path: '/movies',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const DebugDeviceRoute = DebugDeviceRouteImport.update({
            id: '/debug-device',path: '/debug-device',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SeriesIndexRoute = SeriesIndexRouteImport.update({
            id: '/series/',path: '/series/',getParentRoute: () => rootRouteImport
          })
const CategoriesIndexRoute = CategoriesIndexRouteImport.update({
            id: '/categories/',path: '/categories/',getParentRoute: () => rootRouteImport
          })
const StorySlugRoute = StorySlugRouteImport.update({
            id: '/story/$slug',path: '/story/$slug',getParentRoute: () => rootRouteImport
          })
const SeriesSlugRoute = SeriesSlugRouteImport.update({
            id: '/series/$slug',path: '/series/$slug',getParentRoute: () => rootRouteImport
          })
const MovieSlugRoute = MovieSlugRouteImport.update({
            id: '/movie/$slug',path: '/movie/$slug',getParentRoute: () => rootRouteImport
          })
const CategoriesSlugRoute = CategoriesSlugRouteImport.update({
            id: '/categories/$slug',path: '/categories/$slug',getParentRoute: () => rootRouteImport
          })
const CThreadIdRoute = CThreadIdRouteImport.update({
            id: '/c/$threadId',path: '/c/$threadId',getParentRoute: () => rootRouteImport
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => rootRouteImport
          })
const AdminStoriesRoute = AdminStoriesRouteImport.update({
            id: '/admin/stories',path: '/admin/stories',getParentRoute: () => rootRouteImport
          })
const AdminSafelinkRoute = AdminSafelinkRouteImport.update({
            id: '/admin/safelink',path: '/admin/safelink',getParentRoute: () => rootRouteImport
          })
const AdminPreviewRoute = AdminPreviewRouteImport.update({
            id: '/admin/preview',path: '/admin/preview',getParentRoute: () => rootRouteImport
          })
const AdminNewsletterRoute = AdminNewsletterRouteImport.update({
            id: '/admin/newsletter',path: '/admin/newsletter',getParentRoute: () => rootRouteImport
          })
const AdminMonitorRoute = AdminMonitorRouteImport.update({
            id: '/admin/monitor',path: '/admin/monitor',getParentRoute: () => rootRouteImport
          })
const AdminHelpRoute = AdminHelpRouteImport.update({
            id: '/admin/help',path: '/admin/help',getParentRoute: () => rootRouteImport
          })
const AdminContactRoute = AdminContactRouteImport.update({
            id: '/admin/contact',path: '/admin/contact',getParentRoute: () => rootRouteImport
          })
const AdminCommentsRoute = AdminCommentsRouteImport.update({
            id: '/admin/comments',path: '/admin/comments',getParentRoute: () => rootRouteImport
          })
const AdminBlockedCountriesRoute = AdminBlockedCountriesRouteImport.update({
            id: '/admin/blocked-countries',path: '/admin/blocked-countries',getParentRoute: () => rootRouteImport
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRoute
          })
const DashboardPendingRoute = DashboardPendingRouteImport.update({
            id: '/pending',path: '/pending',getParentRoute: () => DashboardRoute
          })
const WatchSlugEpRoute = WatchSlugEpRouteImport.update({
            id: '/watch/$slug/$ep',path: '/watch/$slug/$ep',getParentRoute: () => rootRouteImport
          })
const DownloadMovieSlugRoute = DownloadMovieSlugRouteImport.update({
            id: '/download/movie/$slug',path: '/download/movie/$slug',getParentRoute: () => rootRouteImport
          })
const DownloadSlugEpRoute = DownloadSlugEpRouteImport.update({
            id: '/download/$slug/$ep',path: '/download/$slug/$ep',getParentRoute: () => rootRouteImport
          })





const DashboardRouteChildren = {
  DashboardPendingRoute: DashboardPendingRoute,DashboardIndexRoute: DashboardIndexRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccountRoute: AccountRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,DashboardRoute: DashboardRouteWithChildren,DebugDeviceRoute: DebugDeviceRoute,DisclaimerRoute: DisclaimerRoute,FaqRoute: FaqRoute,LoginRoute: LoginRoute,MoviesRoute: MoviesRoute,PlayRoute: PlayRoute,PrivacyRoute: PrivacyRoute,RandomRoute: RandomRoute,RedirectRoute: RedirectRoute,SafelinkRoute: SafelinkRoute,SearchRoute: SearchRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,AdminBlockedCountriesRoute: AdminBlockedCountriesRoute,AdminCommentsRoute: AdminCommentsRoute,AdminContactRoute: AdminContactRoute,AdminHelpRoute: AdminHelpRoute,AdminMonitorRoute: AdminMonitorRoute,AdminNewsletterRoute: AdminNewsletterRoute,AdminPreviewRoute: AdminPreviewRoute,AdminSafelinkRoute: AdminSafelinkRoute,AdminStoriesRoute: AdminStoriesRoute,AdminUsersRoute: AdminUsersRoute,CThreadIdRoute: CThreadIdRoute,CategoriesSlugRoute: CategoriesSlugRoute,MovieSlugRoute: MovieSlugRoute,SeriesSlugRoute: SeriesSlugRoute,StorySlugRoute: StorySlugRoute,CategoriesIndexRoute: CategoriesIndexRoute,SeriesIndexRoute: SeriesIndexRoute,DownloadSlugEpRoute: DownloadSlugEpRoute,DownloadMovieSlugRoute: DownloadMovieSlugRoute,WatchSlugEpRoute: WatchSlugEpRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)